import * as React from "react";
import clsx from "clsx";
const Text = (props) => {
  const { children, className, element: Element = "div", spacing, whiteSpace } = props;
  return /* @__PURE__ */ React.createElement(
    Element,
    {
      className: clsx(
        "text",
        {
          ["text--".concat(spacing)]: !!spacing,
          ["text--".concat(whiteSpace)]: !!whiteSpace
        },
        className
      )
    },
    children
  );
};
export {
  Text
};
